'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { useHotkeys } from 'react-hotkeys-hook';
import { useWebHaptics } from 'web-haptics/react';

import { useTranslations } from '@/i18n/useTranslations';
import { encodePassphrase, randomRoomName, randomString } from '@/lib/rooms/client-utils';

import PhoneIcon from '@/assets/icons/phone.svg';

import elements from '@/styles/elements.module.sass';
import text from '@/styles/text.module.sass';
import styles from './NewRoomButton.module.sass';

export default function NewRoomButton() {
  const { t } = useTranslations('HomePage');
  const { trigger } = useWebHaptics();
  const router = useRouter();

  const [e2ee, setE2ee] = useState(true);
  const [sharedPassphrase] = useState(randomString(64));
  const [isHotkeyActive, setIsHotkeyActive] = useState(false);

  const onClick = () => {
    const room = randomRoomName();
    trigger('success');
    if (e2ee) {
      router.push(`/${room}#${encodePassphrase(sharedPassphrase)}`);
    } else {
      router.push(`/${room}`);
    }
  };

  useHotkeys('n', () => setIsHotkeyActive(true), { keydown: true });
  useHotkeys(
    'n',
    () => {
      setIsHotkeyActive(false);
      onClick();
    },
    { keyup: true },
  );

  return (
    <>
      <button
        className={styles.button}
        onClick={onClick}
        data-hotkey-active={isHotkeyActive || undefined}
      >
        <div className={styles.buttonHeader}>
          <span className={`${styles.buttonHeaderText} ${text.pBold}`}>{t('newRoom')}</span>
          <kbd className={elements.key}>
            <PhoneIcon width={13} height={13} />N
          </kbd>
        </div>
        <div className={styles.buttonFooter}>
          <p className={text.pAccent}>{t('newRoomDescription')}</p>
        </div>
      </button>
      <label className={text.p} style={{ display: 'none', gap: 8, alignItems: 'center' }}>
        <input type="checkbox" checked={e2ee} onChange={(e) => setE2ee(e.target.checked)} />
        E2EE
      </label>
    </>
  );
}
